import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { useUser } from '../context/UserContext';
import { IoFlag, IoClose, IoCheckmarkCircle } from 'react-icons/io5';
import './ReportButton.css';

const REASONS = [
  { id: 'inappropriate', label: '🚫 Contenu inapproprié' },
  { id: 'spam', label: '📧 Spam / Publicité' },
  { id: 'harassment', label: '⚠️ Harcèlement' },
  { id: 'copyright', label: '©️ Violation de droits d\'auteur' },
  { id: 'other', label: '📝 Autre' },
];

export default function ReportButton({ type, targetId, targetTitle }) {
  const { user } = useUser();
  const [isOpen, setIsOpen] = useState(false);
  const [sent, setSent] = useState(false);
  const [details, setDetails] = useState('');

  const handleReport = async (reason) => {
    await addDoc(collection(db, 'reports'), {
      type,
      targetId,
      targetTitle: targetTitle || '',
      reason: reason.id,
      reasonLabel: reason.label,
      details,
      reporterId: user.id,
      reporterName: user.name,
      status: 'pending',
      createdAt: serverTimestamp(),
    });
    setSent(true);
    setTimeout(() => { setSent(false); setIsOpen(false); setDetails(''); }, 2000);
  };

  return (
    <>
      <motion.button
        className="report-trigger"
        onClick={() => setIsOpen(true)}
        whileTap={{ scale: 0.9 }}
        title="Signaler"
      >
        <IoFlag />
      </motion.button>

      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              className="report-backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => { setIsOpen(false); setSent(false); }}
            />
            <motion.div
              className="report-panel"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
            >
              {sent ? (
                <div className="report-success">
                  <IoCheckmarkCircle className="report-success-icon" />
                  <h3>Merci !</h3>
                  <p>Ton signalement a été envoyé. On va examiner ça.</p>
                </div>
              ) : (
                <>
                  <div className="report-header">
                    <h3>Signaler</h3>
                    <button className="report-close" onClick={() => setIsOpen(false)}><IoClose /></button>
                  </div>
                  <p className="report-subtitle">Pourquoi signales-tu ce contenu ?</p>
                  <div className="report-reasons">
                    {REASONS.map(reason => (
                      <motion.button
                        key={reason.id}
                        className="report-reason"
                        onClick={() => handleReport(reason)}
                        whileTap={{ scale: 0.97 }}
                      >
                        {reason.label}
                      </motion.button>
                    ))}
                  </div>
                  <textarea
                    className="input report-details"
                    placeholder="Détails supplémentaires (optionnel)"
                    value={details}
                    onChange={e => setDetails(e.target.value)}
                    maxLength={500}
                  />
                </>
              )}
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
}